import { atom, useAtom } from 'jotai';

type UseGridHeatmapConfig = {
  gridSize: number;
  setGridSize: (size: number) => void;
};

const gridSizeAtom = atom<number>(125);

const useGridHeatmapConfig = (): UseGridHeatmapConfig => {
  const [gridSize, setGridSize] = useAtom(gridSizeAtom);

  return {
    gridSize: gridSize,
    setGridSize: setGridSize,
  };
};

export { useGridHeatmapConfig };
